module.exports = __webpack_public_path__ + "static/media/10_plantilla_cuadrada_combo_simple_cp_gaseosas_vidrio_350_sp.9849531b.png";